<template>
  <span :class="{ negative: object[field.id] < 0 }">

    <div>{{ formatCurrency(object.signed_paid) }}</div>

    <div v-if="object.refunded_amount"
         class="text-danger small">
      {{ $t('return') }}: {{ formatCurrency(object.refunded_amount) }}
    </div>
  </span>
</template>

<script setup>
import { formatCurrency } from "@/extensions/filters/filters"

defineProps({
  object: {
    type: Object
  },
  field: {
    type: Object
  },
})
</script>
